// extracted by mini-css-extract-plugin
export var askAiIcon = "_ra-9";
export var container = "_ra-0";
export var groupSeparator = "_ra-a";
export var highlight = "_ra-4";
export var resultIcon = "_ra-5";
export var resultItem = "_ra-7";
export var resultSubtitle = "_ra-3";
export var resultTitle = "_ra-2";
export var resultsList = "_ra-1";
export var searchGroup = "_ra-6";
export var selected = "_ra-8";